import i18n from '../../i18n';

export const MESSAGES = {
  FETCH_INTERACTIONS_METADATA: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the interactions metadata.'),
      403: i18n.t('You are not allowed to fetch the interactions metadata.'),
      404: i18n.t('The interactions metadata you are trying to fetch does not exist.'),
      500: i18n.t('Αn error occurred fetching the interactions metadata.'),
      default: i18n.t('Αn error occurred fetching the interactions metadata.')
    }
  },

  FETCH_EVENT_INTERACTIONS_METADATA: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the event interactions metadata.'),
      403: i18n.t('You are not allowed to fetch the event interactions metadata.'),
      404: i18n.t('The event interactions metadata you are trying to fetch does not exist.'),
      500: i18n.t('Αn error occurred fetching the event interactions metadata.'),
      default: i18n.t('Αn error occurred fetching the event interactions metadata.')
    }
  },

  FETCH_EVENT_INTERACTION_VARIABLES: {
    ERROR: {
      401: i18n.t('You are not authorized to fetch the event interaction variables.'),
      403: i18n.t('You are not allowed to fetch the event interaction variables.'),
      404: i18n.t('The event interaction variables you are trying to fetch do not exist.'),
      500: i18n.t('Αn error occurred fetching the event interaction variables.'),
      default: i18n.t('Αn error occurred fetching the event interaction variables.')
    }
  }
};
